import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '@/types/general';
export const Facebook = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g clipPath="url(#clip0_8_4703)"><path d="M9.49994 0.502751C7.10029 0.487663 4.78384 1.38126 3.01601 3.00401C1.24818 4.62675 0.159968 6.8584 -0.0299863 9.25056C-0.219941 11.6427 0.502441 14.0181 1.99201 15.8996C3.48159 17.781 5.62798 19.0289 7.99994 19.3928V12.7528H5.59994V10.0028H7.99994V7.91275C7.94725 7.42431 8.00263 6.93026 8.16216 6.46561C8.3217 6.00095 8.58147 5.57708 8.92309 5.22402C9.2647 4.87095 9.67978 4.59735 10.1389 4.42259C10.5981 4.24783 11.09 4.17619 11.5799 4.21275C12.2937 4.22298 13.0057 4.28649 13.7099 4.40275V6.73275H12.5099C12.3085 6.71296 12.1051 6.73773 11.9143 6.80532C11.7234 6.87291 11.5498 6.98166 11.4057 7.12385C11.2616 7.26604 11.1506 7.4382 11.0804 7.62811C11.0103 7.81802 10.9828 8.02103 10.9999 8.22275V10.0028H13.6399L13.2199 12.7528H10.9999V19.3928C13.3719 19.0289 15.5183 17.781 17.0079 15.8996C18.4974 14.0181 19.2198 11.6427 19.0299 9.25056C18.8399 6.8584 17.7517 4.62675 15.9839 3.00401C14.216 1.38126 11.8996 0.487663 9.49994 0.502751Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <defs><clipPath id="clip0_8_4703"><rect width="19" height="19" fill="white" transform="translate(0 0.502808)" /></clipPath></defs>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props.className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="currentColor" className={props.className}>{t0}{t1}</svg>;
    $[2] = props.className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};